import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import EditStaff from './EditStaff';
import StaffInfoModal from './StaffInfoModal.js';
import AdminEdit from './AdminEdit.js';
import withStaffLookups from '../shared/withStaffLookups';
import { Toast } from 'primereact/toast';

import useToast from '../shared/hooks/useToast';
import api from '../../scripts/api';
import { message } from '../shared/Message';
import StaffDto from '../../DTOs/Staff/StaffDto';
import { useNavigate } from 'react-router';

function StaffAdd({ licenseTypes, staffEducationLevels }) {
  const [staff, setStaff] = useState(new StaffDto());
  const [showStaffInfoModal, setShowStaffInfoModal] = useState(false);
  const [apiResult, setApiResult] = useState(false);
  const effectiveOrganizationId = useSelector(state => state.user.effectiveOrganizationId);
  const currentUserOrganizationId = useSelector(state => state.user.organizationId);
  const addingSiteAdmin = (currentUserOrganizationId === 1 && effectiveOrganizationId === null);
  const navigate = useNavigate();
  const { toast, errorToast } = useToast();

  const openStaffInfoModal = () => {
    setShowStaffInfoModal(true);
  }

  const closeStaffInfoModal = () => {
    setShowStaffInfoModal(false);
  }

  const handleCancelClick = () => navigate("/Staff");

  const addStaffSubmit = (values, actions) => {
    message.dismissAll();
    const dto = new StaffDto({
      ...values,
      isDisabled: !values.isActive,
      educationLevel: staffEducationLevels.filter(kw => kw.value === values.educationLevelValue)[0],
      licenseTypes: licenseTypes.filter(kw => kw.value === values.licenseTypeValue)
    });

    api.addStaff(dto.stringify()).then(() => {
      setApiResult(true);
    }).catch(err => {
      errorToast(`Error submitting new staff: ${err}`);
      message.error(`Error submitting new staff: ${err}`);
      actions.setSubmitting(false);
    });
  }

  const addSiteAdminSubmit = (values, actions) => {
    message.dismissAll();
    const dto = new StaffDto({
      ...values,
      organizationId: 1,
      userRoleId: 1,
      isDisabled: !values.isActive,
      educationLevel: staffEducationLevels.filter(kw => kw.value === values.educationLevelValue)[0],
      licenseTypes: licenseTypes.filter(kw => kw.value === values.licenseTypeValue)
    });

    api.addStaff(dto.stringify()).then(() => {
      setApiResult(true)
    }).catch(err => {
      errorToast(`Error submitting new site admin: ${err}`);
      message.error(`Error submitting new site admin: ${err}`);
      actions.setSubmitting(false);
    });
  }

  return (
    <>
      <Container className="basic-card pb-3">
        {addingSiteAdmin

          ? <AdminEdit
            staff={staff}
            editAction={"Add"}
            redirect={apiResult}
            licenseTypes={licenseTypes}
            staffEducationLevels={staffEducationLevels}
            handleCancelEditClick={handleCancelClick}
            handleFormSubmit={addSiteAdminSubmit}
            siteAdmin
          />
          : <EditStaff
          staff={staff}
          editAction={"Add"}
          redirect={apiResult}
          licenseTypes={licenseTypes}
          staffEducationLevels={staffEducationLevels}
          handleStaffInfoClick={openStaffInfoModal}
          handleCancelEditClick={handleCancelClick}
          handleFormSubmit={addStaffSubmit}
        />
        }
        <Toast ref={toast} position="bottom-left" />
      </Container>

      { showStaffInfoModal ?
        
        <StaffInfoModal
          showModal={showStaffInfoModal}
          hideModal={closeStaffInfoModal}
        />
        : null }
    </>
  );
}

export default withStaffLookups(StaffAdd);
